<template>
    <v-list-item
        :href="menu.route"
    >
        <v-list-item-icon>
            <v-icon
                v-if="menu.icon"
                v-text="menu.icon"
            />
        </v-list-item-icon>

        <v-list-item-title v-text="menu.name"></v-list-item-title>
    </v-list-item>
</template>

<script>
export default {
    props: {
        menu: {
            required: true,
            type: Object,
        },
    },
};
</script>
